import React, { lazy, Suspense, useEffect, useLayoutEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { clarity } from 'react-microsoft-clarity';

import { QuickScan, PodcastZorgprofessionals, Klachtenregeling, AlgemeneVoorwaarden, Offertebrochure, OnderbouwingSubsidieverzoek,
  GidsvoorProfessionals, GidsRedirect, RoutekaartLactatiekundigen, RoutekaartGemeentesBeleidsmedewerkers,
  RoutekaartVerloskundigenJgzKraamzorg, OudersEvaluatie, Gratis, PodcastOuders, PodcastEpisode, PodcastHome,
  Contact, Home, Lactatiekunde, NotFound, OverOns, Verloskunde, Ervaringen, Medewerking, 
  Kosten, ContactFormulier, Temporary, MOM, Kraamzorg, JGZ, Huisarts, Inloggen,
  Gemeente, Kennismaking, OfferteAanvragen,
  Gesprek,
  GesprekDoelgroep} from './pages';


import { BottomFooter, TopFooter, Menu } from './components';
import { Main, Content } from './styled';
import ScrollToTop from "./helpers/ScrollToTop";

import { isPhone, isTablet } from "./helpers/responsive";
import Ouders from "./pages/Ouders/Ouders";

const Zorgprofessionals = lazy(() => import('./pages/Zorgprofessionals/Zorgprofessionals'));

export const GeneralContext = React.createContext();

function App() {
  const [ hasPhone, setHasPhone ] = useState(isPhone(window.screen));
  const [ hasTablet, setHasTablet ] = useState(isTablet(window.screen));

  useLayoutEffect(() => {
    function updateResponsive() {
      setHasPhone(isPhone(window.screen));
      setHasTablet(isTablet(window.screen));
    }
    window.addEventListener('resize', updateResponsive);
    updateResponsive();
    return () => window.removeEventListener('resize', updateResponsive);
  }, []);

  useEffect(() => {
    clarity.init(process.env.REACT_APP_CLARITY_ID) 
  })

  return (
    <GeneralContext.Provider value={{ 'hasPhone' : hasPhone, 'hasTablet': hasTablet }}>
      <Router>
        <Main>
          <Menu />
          <Content>
            <ScrollToTop />
            <Suspense fallback={<div>Aan het laden</div>}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path='ouders'>
                  <Route index element={<Ouders />} />
                </Route>
                <Route path='zorgprofessionals'>
                  <Route index element={<Zorgprofessionals />} />
                  <Route path='lactatiekunde' element={<Lactatiekunde  />} />
                  <Route path='verloskunde' element={<Verloskunde />} />
                  <Route path='kraamzorg' element={<Kraamzorg />} />
                  <Route path='JGZ' element={<JGZ  />} />
                  <Route path='huisarts' element={<Huisarts  />} />
                </Route>
                <Route path='lactatiekunde' element={<Navigate to='/zorgprofessionals/lactatiekunde' replace />} />
                <Route path='verloskunde' element={<Navigate to='/zorgprofessionals/verloskunde' />} />
                <Route path='kraamzorg' element={<Navigate to='/zorgprofessionals/kraamzorg' />} />
                <Route path='JGZ' element={<Navigate to='/zorgprofessionals/JGZ' />} />
                <Route path='huisarts' element={<Navigate to='/zorgprofessionals/huisarts' />} />
                <Route path='/gemeente' element={<Gemeente />} />
                <Route path='/over-ons' element={<OverOns  />} />
                <Route path='/podcast' element={<PodcastHome  />} />
                <Route path='/podcast/ouders' element={<PodcastOuders />} />
                <Route path='/podcast/ouders/:podcastId' element={<PodcastEpisode />} />

                <Route path='/podcast/zorgprofessionals' element={<PodcastZorgprofessionals />} />
                <Route path='/podcast/zorgprofessionals/:podcastId' element={<PodcastEpisode />} />

                <Route path='/contact' element={<Contact  />} />
                <Route path='/ervaringen' element={<Ervaringen  />} />
                <Route path='/vragen' element={<Temporary  />} />
                <Route path='/medewerking' element={<Medewerking  />} />
                <Route path='/kosten' element={<Kosten />} />
                <Route path='/contact-formulier' element={<ContactFormulier />} />
                <Route path='/algemene-voorwaarden' element={<AlgemeneVoorwaarden />} />
                
                <Route path='/offertebrochure' element={<Offertebrochure />} />
                <Route path='/onderbouwing-subsidieverzoek' element={<OnderbouwingSubsidieverzoek />} />
                <Route path='/gids-voor-professionals' element={<GidsvoorProfessionals />} />
                <Route path='/gids' element={<GidsRedirect />} />
                <Route path='/routekaart-lactatiekundigen' element={<RoutekaartLactatiekundigen />} />
                <Route path='/routekaart-verloskundigen-jgz-en-kraamzorg' element={<RoutekaartVerloskundigenJgzKraamzorg />} />
                <Route path='/routekaart-gemeentes-en-beleidsmedewerkers' element={<RoutekaartGemeentesBeleidsmedewerkers />} />

                <Route path='/klachtenregeling' element={<Klachtenregeling />} />
                <Route path='/offerte-aanvragen' element={<OfferteAanvragen />} />
                <Route path='/quickscan' element={<QuickScan />} />
                <Route path='/inloggen' element={<Inloggen />} />

                <Route path='/MOM' element={<MOM />} />
                <Route path='/gratis' element={<Gratis />} />
                <Route path='/lactatiekunde/kennismaking' element={<Kennismaking />} />
                <Route path="evaluatie" element={<OudersEvaluatie />} />
                <Route path='/gesprek'>
                  <Route index element={<Gesprek />} />
                  <Route path=":target_group" element={<GesprekDoelgroep />} />
                </Route>
                <Route path="*" element={<NotFound  />}/>
              </Routes>
            </Suspense>
          </Content>
          <TopFooter  />
          <BottomFooter  />
        </Main>
      </Router>
    </GeneralContext.Provider>
  );
}

export default App;
